import DOMPurify from 'dompurify';
import { DateTime } from 'luxon';

import type { EventsCommunicationType } from '@appTypes/esb';
import { formatToAPIUTCDateTime } from '@utils/datesLuxon';

export const getQueryParams = (organizationGuid: string) => ({
  communicationType: 'Announcement' as EventsCommunicationType,
  everyChildOrganization: 'true',
  fromDate: formatToAPIUTCDateTime(DateTime.now().startOf('day')).slice(0, -5),
  organizationGuid,
  page: 1,
  perPage: 10,
  status: 'active' as const,
  toDate: formatToAPIUTCDateTime(DateTime.now().endOf('day')).slice(0, -5),
});

export const toSafeHtml = (html: string) => {
  const body = DOMPurify.sanitize(html, { RETURN_DOM: true }) as HTMLElement;

  body.querySelectorAll('a[href]').forEach(a => {
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
  });

  return body.innerHTML;
};
